export enum FontSize {
  TextDisplay = '40px',
  TextH1 = '32px',
  TextH2 = '24px',
  TextH3 = '20px',
  TextH4 = '18px',
  TextBodyLG = '16px',
  TextBodyMD = '14px',
  TextBodySM = '12px',
}
